<template>
  <!-- banner -->
  <section v-if="bannerTopo != ''" class="hero-wrap hero-wrap-2"
    :style="{ backgroundImage: 'url(' + $imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
    <div class="overlay"></div>
    <div class="container">
      <div class="row no-gutters slider-text align-items-end">
        <div class="col-md-9 pb-5">
          <h1 class="mb-0 bread">{{ bannerTopo[0].itiNome }}</h1>
        </div>
      </div>
    </div>
  </section>
  <!-- END banner -->

  <!-- orçamento -->
  <section v-if="orcamento != ''" class="ftco-section"
    style="background-image: url('/images/use_your_illusion_orcamento.png'); background-repeat: repeat;">
    <div class="container">
      <div class="row">
        <div class="col-md-12 d-flex align-self-stretch">
          <div class="pb-4 heading-section heading-section-white">
            <h2 class="mb-3">{{ orcamento[0].itiNome }}</h2>
            <p v-html="orcamento[0].itiResumo1" class="mb-4 textoEditor"></p>
          </div>
        </div>

        <!-- formulario -->
        <section class="ftco-section">
          <div class="container">
            <div class="row justify-content-center">
              <div class="col-md-12">
                <div class="wrapper">
                  <div class="row no-gutters">

                    <!-- campos formulario -->
                    <div class="col-md-12 d-flex align-items-stretch">
                      <div class="contact-wrap w-100 p-md-5 p-4">
                        <h3 class="mb-4">Formulário de Orçamento</h3>
                        <form id="contactForm" name="contactForm" class="contactForm" @submit.prevent="enviaremail">
                          <div class="row">
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.nome" type="text" class="form-control" name="nome" id="nome" placeholder="Nome">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.email" type="email" class="form-control" name="email" id="email" placeholder="E-mail">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-mask="'(##) #####-####'" v-model="formulario.fone" type="text" class="form-control" name="fone" id="fone" placeholder="Telefone">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.condominio" type="text" class="form-control" name="condominio" id="condominio"
                                  placeholder="Nome Condomínio">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.cidade" type="text" class="form-control" name="cidade" id="cidade" placeholder="Cidade">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.bairro" type="text" class="form-control" name="bairro" id="bairro" placeholder="Bairro">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <select v-model="formulario.predio" class="form-control" name="predio" id="predio" placeholder="Tipo de Prédio">
                                  <option value="">Selecione o Tipo de Prédio</option>
                                  <option value="Hotel">Hotel</option>
                                  <option value="Hospital">Hospital</option>
                                  <option value="Escola">Escola</option>
                                  <option value="Residencial">Residencial</option>
                                  <option value="Escritorio">Escritório</option>
                                  <option value="Outro">Outro</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.marca" type="text" class="form-control" name="marca" id="marca" placeholder="Marca (opcional)">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.elevadores" type="text" class="form-control" name="elevadores" id="elevadores" placeholder="Quantidade Elevadores (opcional)">
                              </div>
                            </div>
                            <div class="col-md-6">
                              <div class="form-group">
                                <input v-model="formulario.andares" type="text" class="form-control" name="andares" id="andares" placeholder="Quantidade Andares (opcional)">
                              </div>
                            </div>
                            <div class="col-md-12">
                              <div class="form-group">
                                <textarea v-model="formulario.mensagem" name="mensagem" class="form-control" id="mensagem" cols="30" rows="5"
                                  placeholder="Mensagem"></textarea>
                              </div>
                            </div>
                            <div class="col-md-12">
                              <center> <vue-recaptcha
                  ref="recaptcha"
                  :sitekey="siteKey"
                  @verify="onVerify"
                  @expired="onExpired"
                /></center>
                              <div class="form-group" style="margin-top: 30px;">
                                <center>  <input type="submit" value="Solicitar Orçamento" class="btn btn-primary">
                                <div class="submitting"></div></center>
                              </div>
                            </div>
                          </div>
                        </form>
                      </div>
                    </div>
                    <!-- END campos formulario -->

                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

      </div>
    </div>
  </section>
  <!-- END orçamento -->
</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios';
import { VueRecaptcha}  from 'vue-recaptcha'

export default {
  name: 'OrcamentoView',
  components: {
    VueRecaptcha
  },

  data: () => ({
    bannerTopo: [],
    orcamento: [],
    contato: [],

    formulario: {
      nome: "",
      email: "",
      fone: "",
      condomimnio: "",
      cidade: "",
      bairro: "",
      predio: "",
      marca: "",
      elevadores: "",
      andares: "",
      mensagem: "",
    },
    placeholders: {
        nome: 'Nome',
        email: 'E-mail',
        fone: 'Telefone',
        condominio: 'Nome Condomínio',
        cidade: 'Cidade',
        bairro: 'Bairro',
        predio: 'Tipo de Prédio',
        marca: 'Marca (opcional)',
        elevadores: 'Quantidade Elevadores (opcional)',
        andares: 'Quantidade Andares (opcional)',
        mensagem: 'Mensagem'
      },
      siteKey: '6LdRcgUrAAAAALAV8D3c6asztLjI2e6knQS6Jjx2',
      recaptchaVerificado: false,
      recaptchaToken: '',
      seoHome: [],

  }),

  methods: {

    enviaremail() {
      if (this.formulario.nome == '' || this.formulario.nome == null) {
        this.$mensagemErro('Nome obrigatório!');
      }
      else if (this.formulario.email == '' || this.formulario.email == null) {
        this.$mensagemErro('E-mail obrigatório!');
      }
      else if (this.formulario.fone == '' || this.formulario.fone == null) {
        this.$mensagemErro('Telefone obrigatório!');
      }
      else if (this.formulario.condominio == '' || this.formulario.condominio == null) {
        this.$mensagemErro('Nome Condomínio obrigatório!')
      }
      else if (this.formulario.cidade == '' || this.formulario.cidade == null) {
        this.$mensagemErro('Cidade obrigatório!')
      }
      else if (this.formulario.bairro == '' || this.formulario.bairro == null) {
        this.$mensagemErro('Bairro obrigatório!')
      }
      else if (this.formulario.predio == '' || this.formulario.predio == null) {
        this.$mensagemErro('Tipo de obrigatório!')
      }
      else if (!this.recaptchaVerificado){
        this.$mensagemErro('Por favor, confirme que você não é um robô.');
      }
      else {
        //aqui vai o processo de enviar email
        let _dadosEmail = {
          nomeDe: this.formulario.nome,
          nomePara: "Performance Elevadores",
          assunto: 'Orçamento do Site - ' + this.formulario.nome,
          destinatario: this.contato[0].itiCampoExtra1,
          emailResposta: this.formulario.email,
          textoEmail: "Nome: " + this.formulario.nome + "<br>" 
          + "E-mail: " + this.formulario.email + "<br>" 
          + "Telefone:" + this.formulario.fone + "<br>" 
          + "Condomínio:" + this.formulario.condominio + "<br>" 
          + "Cidade:" + this.formulario.cidade + "<br>" 
          + "Bairro:" + this.formulario.bairro + "<br>" 
          + "Prédio:" + this.formulario.predio + "<br>" 
          + "Marca:" + this.formulario.marca + "<br>" 
          + "Elevadores:" + this.formulario.elevadores + "<br>" 
          + "Andares:" + this.formulario.andares + "<br>" 
          + "Mensagem: " + this.formulario.mensagem,
          nomeAnexo: '',
          anexo: '',
          tipoAnexo: '',
          recaptchaToken: this.recaptchaToken
        }
        axios.post('/Process/AdmControleSmtp/Enviamail', _dadosEmail)
          .then(response => {
              this.$mensagemSucesso(response.data.message)
              this.limparFormulario();
          }).finally(() => {
            this.$refs.recaptcha.reset(); // reseta o reCAPTCHA após envio
            this.recaptchaVerificado = false;
          });
      }


    },

    limparFormulario() {
      this.formulario.nome = '';
      this.formulario.email = '';
      this.formulario.fone = '';
      this.formulario.condominio = '';
      this.formulario.cidade = '';
      this.formulario.bairro = '';
      this.formulario.predio = '';
      this.formulario.marca = '';
      this.formulario.elevadores = '';
      this.formulario.andares = '';
      this.formulario.mensagem = '';
    },

    carregaMetas(titulo, texto, palavrasChave) {
      useHead({
        title: titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Performance Elevadores" },
          { name: "keywords", content: palavrasChave }, 
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    textoLimpoSemHtml(value) {
      return value.replace(/<[^>]*>/g, '');
    },
    
  },

  created() {

 axios.get('/Process/InsInstitucional/institucional/54/seoorcamento/0/x')
      .then(response => {
        this.seoHome = response.data;
         let seoHome0 = this.seoHome[0];
         seoHome0.itiResumo1 = this.textoLimpoSemHtml(seoHome0.itiResumo1);
         seoHome0.itiResumo2 = this.textoLimpoSemHtml(seoHome0.itiResumo2);

         this.carregaMetas(seoHome0.itiNome, seoHome0.itiResumo1, seoHome0.itiResumo2);
        //console.log('topo seo')
        //console.log(this.seoHome)
      })
      .catch(error => {
        console.error(error);
      });


    //aqui busca banner topo
    axios.get('/Process/InsInstitucional/institucional/45/orcamentotopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        //console.log('topo banner')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });
    //aqui busca orcamento
    axios.get('/Process/InsInstitucional/institucional/46/orcamento/0/x')
      .then(response => {
        this.orcamento = response.data;
        //console.log('orçamento')
        //console.log(this.orcamento)
      })
      .catch(error => {
        console.error(error);
      });
      //aqui busca quem é contato destino
    axios.get('/Process/InsInstitucional/institucional/16/contato/0/x')
      .then(response => {
        this.contato = response.data;
        //console.log('contato')
        //console.log(this.contato)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style scoped></style>